<template>
  <ReviewGroup ref="ReviewGroup" class="iv-p-b-40" :tableData="members">
    <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-12">设置打分</h1>
    <FormLayout ref="FormLayout" class="iv-p-b-40" :readOnly="type == 'see'" :model="setInfo" :list="setForm" @on-change="changeRadio"></FormLayout>
    <FooterOperator>
      <div class="iv-text-center">
        <Button class="iv-m-r-8" type="submit" @click="saveInfo('')" v-if="reviewGroupInfo.isLeaderCanModify == '1' && type != 'see'">保存</Button>
        <Button class="iv-m-r-8" type="restore" @click="startReview('SS01')" v-if="type != 'see'">启动打分</Button>
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
  </ReviewGroup>
</template>

<script>
import setForm from './set-form.js'
import FormLayout from '@/components/layout/form'
import ReviewGroup from '../components/review-group'
import FooterOperator from '@/components/footer-operator'
import { get, update, publicInfo } from '../interface/index.js'

export default {
  data () {
    return {
      setInfo: {},
      members: [],
      dictMap: {},
      setForm: [],
      reviewGroupInfo: {} //评审组信息
    }
  },
  async created () {
    this.type = this.$decode(this.$route.query.type)
    this.reviewTeamId = this.$decode(this.$route.query.reviewTeamId)
    this.reviewInfoId = this.$decode(this.$route.query.reviewInfoId)
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    this.getCodeTable('BOE36')
    this.getCodeTable('BOE38')
    await this.getCodeTable('BOE35')
    this.getRevireGroupInfo()
    // const writeList = this.dynamicGenerateOptionList()
    // this.setForm = setForm.call(this, writeList)
  },
  methods: {
    //获取评审组信息
    getRevireGroupInfo () {
      get({reviewTeamId: this.reviewTeamId}).then(({data}) => {
        this.members = data.members.map(item => ({
          ...item,
          disabled: data.isLeaderCanModify != '1' || this.type == 'see',
          operateAuthority: item.operateAuthority ? item.operateAuthority.split(',') : []
        }))
        this.reviewGroupInfo = data
        //打分方式
        this.setInfo.scoreExplain = data.scoreExplain || ''
        this.setInfo.scoringMethod = data.scoringMethod || ''
        if (this.setInfo.scoringMethod === 'DFFS01') {
          this.setInfo.highestScore = data.highestScore || 0
          this.setInfo.lowestScore = data.lowestScore || 0
        }
        if (this.setInfo.scoringMethod === 'DFFS02') {
          this.setInfo.perVoteScore = data.perVoteScore || 0
          this.setInfo.maxVote = data.maxVote || 0
        }
        if (this.setInfo.scoringMethod === 'DFFS03') {
          this.setInfo.scoreFieldDict = data.scoreFieldDict || ''
        }
        this.setInfo.writeBackFields = data.writeBackFields ? data.writeBackFields.split(',') : []
        this.changeRadio({}, this.setInfo.scoringMethod)
      })
    },
    //保存
    saveInfo (info) {
      return new Promise((resolve, reject) => {
        const tableParams = this.$refs.ReviewGroup.getTableData().map(item => ({
          ...item,
          operateAuthority: item.operateAuthority.join()
        }))
        this.$refs.FormLayout.validate((validate) => {
          if (!validate) return
          update({
            reviewTeamId: this.reviewGroupInfo.reviewTeamId,
            reviewTeamName: this.reviewGroupInfo.reviewTeamName,
            ...this.setInfo,
            writeBackFields: this.setInfo.writeBackFields.join(),
            members: tableParams
          }).then(({data}) => {
            if (!info) {
              this.$Message.success('保存成功')
            }
            resolve()
          })
        })
      })
    },
    //启动评审
    async startReview (state) {
      if (this.reviewGroupInfo.isLeaderCanModify == '1') {
        await this.saveInfo('qidong')
      }
      publicInfo({reviewInfoId: this.reviewInfoId}).then(data => {
        this.$Message.success(`启动成功`)
        this.back()
      })
    },
    //回写更新字段 动态调整
    dynamicGenerateOptionList (type) {
      const writeBack = this.dictMap['BOE38']
      return Object.keys(writeBack).map(item => {
        if (!type) {
          return {
            label: writeBack[item],
            value: item
          }
        }
        if (type === 'score' && item != 'objectRank') {
          return {
            label: writeBack[item],
            value: item
          }
        } else if (type === 'rank' && (item == 'objectRank' || item == 'objectOrderNum' || item == 'objectOpinion')) {
          return {
            label: writeBack[item],
            value: item
          }
        } else {
          return null
        }
      }).filter(v => v)
    },
    //选择打分方式
    changeRadio (item, val) {
      if (item.key == 'writeBackFields') return
      if (val === 'DFFS01') {
        const writeList = this.dynamicGenerateOptionList('score')
        this.setForm = setForm.call(this, writeList)
        this.setForm.splice(1, 0, this.generateFormItem('分值', 'highestScore', '分'), this.generateFormItem('最低分', 'lowestScore', '分'))
      } else if (val === 'DFFS02') {
        const writeList = this.dynamicGenerateOptionList('score')
        this.setForm = setForm.call(this, writeList)
        this.setForm.splice(1, 0, this.generateFormItem('每票分数', 'perVoteScore', '分'), this.generateFormItem('最高投票数', 'maxVote', '票'))
      } else {
        const writeList = this.dynamicGenerateOptionList('rank')
        this.setForm = setForm.call(this, writeList)
        this.setForm.splice(1, 0, {
          type: 'Select',
          title: '定级',
          [$field]: 'scoreFieldDict',
          optionList: Object.keys(this.dictMap['BOE36']).map(item => ({
            label: this.dictMap['BOE36'][item],
            value: item
          })),
          rules: ['required']
        })
      }
    },
    //生成表单对象  根据打分方式动态生成相应的选项
    generateFormItem (title, field, unit) {
      return {
        type: 'Number',
        title: title,
        [$field]: field,
        props: {
          unit: unit || null
        },
        rules: ['required']
      }
    },
    //数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = {}
          data.data.length &&  data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    },
    //返回
    back () {
      this.$router.push({
        name: 'reviewList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  },
  components: {
    FormLayout,
    ReviewGroup,
    FooterOperator
  }
}
</script>
